import "./style.css"

function Error() {

    return (
        <div className='page page_error'>
            
        </div>
    )
}

export default Error;